import { urlJoin } from '../helpers/urlJoin';

export default {
  DOMAIN: window.location.host,
  GOOGLE_MAPS_API_KEY: ((window as never)['kabernetContext'] as any).googleJavascriptApiKey,
  IS_ESTATE_AGENCY_MODE: ((window as never)['kabernetContext'] as any).isEstateAgencyMode,
  ENVIRONMENT: ((window as never)['kabernetContext'] as any).environment as number,
  LANGUAGE: (window as never)['languageId'] as string,
  BASE_URL: (window as never)['baseUrl'] as string,
  FRONT_RELATIVE_URL: ((window as never)['kabernetContext'] as any).frontRelativeUrl,
  FRONT_RELATIVE_APP_URL: ((window as never)['kabernetContext'] as any).frontRelativeAppUrl,
  EXTERNAL_LOGIN_URL: urlJoin((window as never)['baseUrl'] as string, 'external-login'),
  PRIVACY_URL: ((window as never)['kabernetContext'] as any).privacyUrl,
  GENERAL_TERMS_URL: ((window as never)['kabernetContext'] as any).generalTermsUrl,
  COMPETITION_TERMS_URL: ((window as never)['kabernetContext'] as any).competitionTermsUrl,
  COMPETITION_TERMS_AGENT_URL: ((window as never)['kabernetContext'] as any).competitionTermsAgentUrl,
  COMPETITION_TERMS_AGENT_URL2: ((window as never)['kabernetContext'] as any).competitionTermsAgentUrl2,
  ABOUT_US_URL: ((window as never)['kabernetContext'] as any).aboutUsUrl,
  INFORMATION_ABOUT_NEW_FEATURES_URL: ((window as never)['kabernetContext'] as any).informationAboutNewFeaturesUrl,
  CAREER_URL: ((window as never)['kabernetContext'] as any).careerUrl,
  ADVERTISING_URL: ((window as never)['kabernetContext'] as any).advertisingUrl,
  INVESTOR_INFORMATION_URL: ((window as never)['kabernetContext'] as any).investorInformationUrl,
  CONTACT_URL: ((window as never)['kabernetContext'] as any).contactUrl,
  COMPLAINT_URL: ((window as never)['kabernetContext'] as any).complaintUrl,
  FACEBOOK_URL: ((window as never)['kabernetContext'] as any).facebookUrl,
  LINKEDIN_URL: ((window as never)['kabernetContext'] as any).linkedinUrl,
  OBJECTS: ((window as never)['kabernetContext'] as any).objects,
  IS_DATA_DRIVEN_STYLING_ENABLED: ((window as never)['kabernetContext'] as any).isDataDrivenStylingEnabled,
  IS_PRERENDER: ((window as never)['kabernetContext'] as any).isPrerender,
  DEFAULT_PHONE_PREFIX: {
    country: 'sk',
    value: '+421',
  },
  PHONE_PREFIXES: [
    {
      country: 'uk',
      value: '+44',
    },
    {
      country: 'cz',
      value: '+420',
    },
    {
      country: 'fr',
      value: '+33',
    },
    {
      country: 'hu',
      value: '+36',
    },
    {
      country: 'de',
      value: '+49',
    },
    {
      country: 'pl',
      value: '+48',
    },
    {
      country: 'ru',
      value: '+7',
    },
    {
      country: 'sk',
      value: '+421',
    },
    {
      country: 'es',
      value: '+34',
    },
    {
      country: 'it',
      value: '+39',
    },
    {
      country: 'ua',
      value: '+380',
    },
  ],
};
